import { render, staticRenderFns } from "./ContentSliderWidget.vue?vue&type=template&id=751035f6&"
import script from "./ContentSliderWidget.vue?vue&type=script&lang=ts&"
export * from "./ContentSliderWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports